<template>
  <p>Please upload the missing templates and assets before continuing.</p>

  <div class="missing-container">
    <h2>Missing Templates</h2>
    <v-table density="compact">
      <thead>
        <tr>
          <th class="text-left">Template Name</th>
          <th class="text-left">Origin Template UUID</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="[template_uid, template_name] in missingTemplates"
          :key="item">
          <td>{{ template_name }}</td>
          <td>{{ template_uid }}</td>
        </tr>
      </tbody>
    </v-table>
  </div>

  <div class="missing-container">
    <h2>Missing Assets</h2>
    <v-table density="compact">
      <thead>
        <tr>
          <th class="text-left">Asset Name</th>
          <th class="text-left">Origin Asset UUID</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="[template_uid, template_name] in missingAssets"
          :key="item">
          <td>{{ template_name }}</td>
          <td>{{ template_uid }}</td>
        </tr>
      </tbody>
    </v-table>
  </div>
</template>
<script setup>
import { computed } from 'vue';
const props = defineProps(['customState']);

const missingTemplates = computed(() => props.customState.missing_templates);
const missingAssets = computed(() => props.customState.missing_assets);

console.log({ props });
</script>
<style scoped>
.missing-container {
  margin: 10px;
}
</style>
